import { all } from 'redux-saga/effects';
import { activitiesSaga } from './activitiesSaga';
import { authSaga } from './authSaga';
import { checklistSaga } from './checklistSaga';
import { eventsSaga } from './eventsSaga';
import { participantsSaga } from './participantsSaga';
import { partnersSaga } from './partnersSaga';
import { posterSaga } from './posterSaga';
import { profileSaga } from './profileSaga';
import { discoverySaga } from './discoverySaga';
import { publicProfileSaga } from './publicProfileSaga';

export function* rootSaga() {
  yield all([
    authSaga(),
    eventsSaga(),
    activitiesSaga(),
    participantsSaga(),
    partnersSaga(),
    checklistSaga(),
    posterSaga(),
    profileSaga(),
    discoverySaga(),
    publicProfileSaga(),
  ]);
}
